const WALLET_ACTIVE_TAB_STORAGE_KEY = "walletActiveTab";
const WALLET_TAB_INTENT_EVENT = "webhall:wallet-tab-intent";

export const publishWalletTabIntent = (tabIndex: number): void => {
  if (typeof window === "undefined") return;

  try {
    window.localStorage.setItem(WALLET_ACTIVE_TAB_STORAGE_KEY, `${tabIndex}`);
  } catch (_error) {
    // The same-document event still keeps an already-mounted Wallet usable.
  }

  window.dispatchEvent(
    new CustomEvent(WALLET_TAB_INTENT_EVENT, {
      detail: { tabIndex },
    }),
  );
};

export const subscribeWalletTabIntent = (
  listener: (tabIndex: number) => void,
): (() => void) => {
  if (typeof window === "undefined") return () => undefined;

  const handleIntent = (event: Event) => {
    const tabIndex = (event as CustomEvent<{ tabIndex?: unknown }>).detail
      ?.tabIndex;
    if (typeof tabIndex !== "number" || !Number.isFinite(tabIndex)) return;

    listener(tabIndex);
    try {
      window.localStorage.removeItem(WALLET_ACTIVE_TAB_STORAGE_KEY);
    } catch (_error) {
      // The mounted Wallet already consumed the intent.
    }
  };

  window.addEventListener(WALLET_TAB_INTENT_EVENT, handleIntent);
  return () => window.removeEventListener(WALLET_TAB_INTENT_EVENT, handleIntent);
};
